export default {
  apiKey: 'AIzaSyDwRGxlKhHPP5fmv0J-p6n80C7iP8EpZFU',
  authDomain: 'clublink.firebaseapp.com',
  databaseURL: 'https://clublink.firebaseio.com',
  projectId: 'clublink',
  storageBucket: 'clublink.appspot.com',
  messagingSenderId: '317847309523',
  appId: '1:317847309523:web:5755f53089dcb2c8'
}
